import { generateActions } from "utils";


export const GET_BANKS = generateActions("GET_BANKS");
export const VERIFY_ACCOUNT = generateActions("VERIFY_ACCOUNT");
export const TRANSFER_FUND = generateActions("TRANSFER_FUND");
export const ADD_TRANSACTION = generateActions("ADD_TRANSACTION");
